import React from 'react'
import { Pane, Text } from 'evergreen-ui'
import { MESSAGES } from '../../../config/admissionRound'

const StatusRegister_6 = ({ DataRegister }) => {
  return (
    <>
      <Pane
        color="#1b4332"
        fontWeight={700}
        backgroundColor="#d8f3dc"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontFamily=""
        justifyContent="flex-start"
      >
        <Text color="#1b4332" fontWeight={700}>
          ยืนยันสิทธิ์ {DataRegister[0].QUOTA_NAME}{" "}
          {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
        </Text>
        <Text color="#1b4332" fontWeight={700}>
          {DataRegister[0].Major1_faculty_name}{" "}
          {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
        </Text>
        <br />
        <Text color="#1b4332" fontWeight={700}>
          {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
        </Text>
      </Pane>
      <Pane
        color="#aa3000ff"
        fontWeight={700}
        backgroundColor="#d40000ff"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontFamily=""
        justifyContent="flex-start"
      >
        <Text color="#ffffffff" fontWeight={700}>
          {MESSAGES.reportAfterPay}
        </Text>

      </Pane>
    </>

  )
}

export default StatusRegister_6
